import React from 'react'
import isEmpty from 'lodash/isEmpty'
import type { CreateOrderFromConversationButtonProps } from '@ztechapps/webui.contract'
import { documentLinkKinds } from '@ztechapps/chat.common'
import { useHistory } from '@ztechapps/common.hook'
import { BusyButton } from '@ztechapps/webui.button'
import {
  orderFromConversationDeniedTitle,
  useCanCreateOrderFromConversation,
} from './useCanCreateOrderFromConversation'
import { useCreateOrderFromConversation } from './useCreateOrderFromConversation'

export const CreateOrderFromConversationButton = ({ chat }: CreateOrderFromConversationButtonProps) => {
  const history = useHistory()
  const { canCreateOrderFromConversation } = useCanCreateOrderFromConversation()
  const { createOrderAndOpen, loading } = useCreateOrderFromConversation({
    onSuccessSubmit: (route) => history.push(route),
  })

  // Nothing to create from until the conversation loads; a linked conversation cannot take another order.
  if (!chat || !isEmpty(documentLinkKinds(chat))) return null

  return (
    <BusyButton
      icon="plus"
      text="Create Sales Order"
      busyText="Creating..."
      title="Create a sales order from this conversation."
      isBusy={loading}
      disabledReason={canCreateOrderFromConversation ? undefined : orderFromConversationDeniedTitle}
      onClick={() => createOrderAndOpen(chat)}
    />
  )
}
